import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=7701b32e&"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports